import React from 'react'
import { toIntOrNull } from '@/utils/numberUtilities'

function NumberUnformattedRenderer ({ value }) {
  const int = toIntOrNull(value)
  return <span style={{ float: 'right' }}>{int}</span>
}

export { NumberUnformattedRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/renderers/numberUnformattedRenderer.js